<template>
  <div
    @click="$emit('click')"
    @touchstart="
      (e) => {
        $emit('touchstart', e);
      }
    "
    @mousedown="
      (e) => {
        $emit('touchstart', e);
      }
    "
    @mousemove="
      (e) => {
        $emit('touchmove', e);
      }
    "
    @touchmove="
      (e) => {
        $emit('touchmove', e);
      }
    "
    @touchend="
      (e) => {
        $emit('touchend', e);
      }
    "
    @mouseup="
      (e) => {
        $emit('touchend', e);
      }
    "
    :style="{
      width: widthShow,
      height: heightShow,
      'background-size': '100% 100%',
      'background-repeat': 'no-repeat',
      'background-image': 'url(' + src + ')',
      'z-index': zIndex,
      position: 'relative',
      transform: transform,
      left: aligncenter ? '50%' : 'unset',
      top: justifycenter ? '50%' : 'unset',
    }"
    v-if="src"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "LingangyyhDlImage",
  props: {
    src: {
      default: null,
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
    zIndex: {
      type: [Number, String],
      default: "1",
    },
    aligncenter: {
      type: Boolean,
      default: false,
    },
    justifycenter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    transform() {
      if (this.aligncenter && this.justifycenter) {
        return "translate(-50%, -50%)";
      } else if (this.aligncenter) {
        return "translate(-50%, 0)";
      } else if (this.justifycenter) {
        return "translate(0,-50%)";
      }
      return "unset";
    },
    widthShow() {
      if (this.width && typeof this.width == "number") {
        return "calc(" + (this.width / 6.4).toFixed(2) + " * var(--app-vw))";
      }
      return this.width;
    },
    heightShow() {
      if (this.height && typeof this.height == "number") {
        return "calc(" + (this.height / 6.4).toFixed(2) + " * var(--app-vw))";
      }
      return this.height;
    },
  },
  data() {
    return {};
  },

  mounted() {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/DlImage2.vue